import { render, staticRenderFns } from "./KpTextArea.vue?vue&type=template&id=74406fcb&scoped=true"
import script from "./KpTextArea.vue?vue&type=script&lang=js"
export * from "./KpTextArea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74406fcb",
  null
  
)

export default component.exports